import { motion } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import Icon from "./Icon";
import mascotThinking from "../assets/MascotThinking.png";

function ProblemSolution() {
  return (
    <section className="py-24 px-8 bg-surface-container-low">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            className="order-2 md:order-1 relative overflow-hidden aspect-square"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
          >
            <img
              alt="Mascot thinking"
              className="w-full h-full object-contain object-top"
              src={mascotThinking}
            />
            <div className="absolute bottom-0 left-0 right-0 h-1/4 bg-gradient-to-t from-surface-container-low to-transparent"></div>
          </motion.div>

          {/* Text Content */}
          <div className="order-1 md:order-2 space-y-6">
            <AnimatedSection direction="right">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-container/10 text-primary rounded-full text-sm font-bold">
                <span className="w-1.5 h-1.5 bg-primary rounded-full"></span>
                The Problem
              </div>
            </AnimatedSection>

            <AnimatedSection direction="right" delay={0.1}>
              <h2 className="font-headline text-4xl font-bold tracking-tight text-on-surface">
                Small needs shouldn't be big problems.
              </h2>
            </AnimatedSection>

            <AnimatedSection direction="right" delay={0.2}>
              <p className="text-lg text-on-surface-variant leading-relaxed">
                We all have those "micro-tasks"—tasks too small for a professional service, but too important to ignore. Finding someone you trust nearby is usually chaotic and unstructured.
              </p>
            </AnimatedSection>

            <AnimatedSection direction="right" delay={0.3}>
              <div className="pt-4 space-y-4">
                <div className="flex gap-4">
                  <Icon name="close" className="text-primary-container" />
                  <span className="text-on-surface-variant">Inconsistent quality from random groups</span>
                </div>
                <div className="flex gap-4">
                  <Icon name="close" className="text-primary-container" />
                  <span className="text-on-surface-variant">Uncertainty about security and payment</span>
                </div>
                <div className="flex gap-4">
                  <Icon name="check_circle" className="text-primary-container" />
                  <span className="text-on-surface font-semibold">SOLID solves this with structured, contract-based favors.</span>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProblemSolution;
